import { useSyncExternalStore } from "react";
import { getLikedTracks, isLiked, subscribeLikedTracks, type LikedTrackEntry } from "./likedTracks.js";

const EMPTY: LikedTrackEntry[] = [];

/** Live view of `likedTracks.ts`'s localStorage list — no network involved. */
export function useLikedTracks(): LikedTrackEntry[] {
  return useSyncExternalStore(subscribeLikedTracks, getLikedTracks, () => EMPTY);
}

/**
 * Live per-track liked state. Many `LikeButton`s render at once (e.g. a search results list);
 * each subscribes independently rather than every row re-deriving membership from the full list.
 */
export function useIsLiked(smId: string): boolean {
  return useSyncExternalStore(
    subscribeLikedTracks,
    () => isLiked(smId),
    () => false,
  );
}
